/**
 * Pakiety kredytow oferowane w panelu konta. Jedno zrodlo dla przyciskow zakupu
 * (UserProfileDialog) i dla regulaminu (terms-page podstawia je pod {creditPackages}) —
 * regulamin nie moze wymieniac innych pakietow niz te, ktore da sie kupic.
 */
export const CREDIT_PACKAGES = [100, 200, 500] as const

/** 1 kredyt = 0,10 zl. Przelicznik w jednym miejscu, zeby cena na przycisku i w regulaminie nie mogla sie rozjechac. */
export const creditsToPln = (credits: number) => credits / 10
